import { useState } from "react";

import Lisa from "../assets/img/Lisa.jpg";
import Lyanne from "../assets/img/Lyanne.jpg";
import Melissa from "../assets/img/Melissa.png";
import Nellie from "../assets/img/Nellie.jpg";
import Ran from "../assets/img/Ran.jpg";
import Taske from "../assets/img/Taske.jpg";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const TESTIMONIALS = [
  {
    name: "Lisa",
    image: Lisa,
    description: `I'm super happy with the work Fazi has been doing. The
                    quality is always top-notch, he delivers everything right on
                    time, and he really takes the time to think along with me.
                    He doesn't just follow instructions, he actually adds value
                    with his input and ideas. It's rare to find someone this
                    reliable and easy to work with. Definitely recommend him!`,
  },
  {
    name: "Ran",
    image: Ran,
    description: `I've been working with Fazi for nearly two years across a
                    wide range of niches, and he continues to impress me with
                    both his talent and reliability. He's not only incredibly
                    skilled as a video editor, but also a genuinely kind and
                    easygoing person to collaborate with. His attention to
                    detail, creative input, and understanding of different
                    styles make the editing process smooth and efficient. I
                    truly hope to continue working with Fazi for many years to
                    come—and I'd wholeheartedly recommend him to anyone looking
                    for a top-tier video editor.`,
  },
  {
    name: "Melissa",
    image: Melissa,
    description: `Fazi has been amazing to work with! He's not only super
                    skilled and creative, but also incredibly kind and always
                    open to feedback. He really listens and makes sure each
                    video turns out just right. I couldn't ask for a better
                    collaborator—highly recommend Fazi!`,
  },
  {
    name: "Lyanne",
    image: Lyanne,
    description: `I'm very satisfied with the videos he creates for me, both
                    in the sports niche and the geopolitics niche. He always
                    delivers on time, sticks to agreements, and is reliable.
                    Communication is smooth and professional. The price-quality
                    ratio is excellent — definitely worth it. Highly
                    recommended!`,
  },
  {
    name: "Nellie",
    image: Nellie,
    description: `I've been working with this editor for quite a while now,
                    and it's been a really great experience. He's fast, knows
                    what he's doing, thinks along with me, and is super easy to
                    work with. Over time, you really get in tune with each
                    other, and that makes things even smoother. Communication
                    gets better, the process gets faster, and the results stay
                    top-notch. If you're looking for a great editor — stop
                    scrolling, you've just found one!`,
  },
  {
    name: "Taske",
    image: Taske,
    description: `I have been working with Fazi for a while now and I really
                    appreciate it. The communication is clear and transparent,
                    he delivers quickly, the quality of the videos is great and
                    Fazi is very helpful. I am happy to work with him for my
                    youtube channel and hope to work with him for my other
                    channels in the future!`,
  },
];

const TestimonialCard = ({ item }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="testimonials-item"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "relative",
        background: hover
          ? "linear-gradient(160deg, rgba(255,255,255,0.16), rgba(255,255,255,0.05))"
          : "linear-gradient(160deg, rgba(255,255,255,0.10), rgba(255,255,255,0.03))",
        backdropFilter: "blur(22px) saturate(160%)",
        WebkitBackdropFilter: "blur(22px) saturate(160%)",
        border: hover
          ? "1px solid rgba(255, 255, 255, 0.35)"
          : "1px solid rgba(255, 255, 255, 0.16)",
        borderRadius: "26px",
        padding: "44px 30px 36px",
        margin: "16px",
        textAlign: "center",
        transform: hover ? "translateY(-10px)" : "translateY(0)",
        boxShadow: hover
          ? "0 20px 45px rgba(31, 10, 60, 0.55), inset 0 1px 0 rgba(255,255,255,0.4), 0 0 30px rgba(185, 60, 232, 0.25)"
          : "0 12px 32px rgba(20, 6, 40, 0.4), inset 0 1px 0 rgba(255,255,255,0.25)",
        transition: "all 0.4s ease",
        minHeight: "420px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Glass sheen highlight across the top */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "45%",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 100%)",
          pointerEvents: "none",
        }}
      />

      {/* Decorative quote mark */}
      <div
        style={{
          position: "absolute",
          top: "14px",
          left: "26px",
          fontSize: "68px",
          lineHeight: 1,
          fontFamily: "Georgia, serif",
          color: "rgba(255, 255, 255, 0.22)",
          userSelect: "none",
        }}
      >
        “
      </div>

      {/* Avatar with gradient ring */}
      <div
        style={{
          width: 108,
          height: 108,
          borderRadius: "50%",
          padding: "4px",
          marginBottom: 16,
          background: "linear-gradient(135deg, #7b2ff7, #b93ce8, #ff7ce5)",
          boxShadow: hover
            ? "0 0 25px rgba(185, 60, 232, 0.6)"
            : "0 0 14px rgba(123, 47, 247, 0.35)",
          transition: "box-shadow 0.35s ease",
          position: "relative",
          zIndex: 1,
        }}
      >
        <img
          src={item?.image}
          alt={item.name}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
            border: "3px solid rgba(255,255,255,0.15)",
            display: "block",
          }}
        />
      </div>

      {/* Star rating */}
      <div
        style={{
          color: "#ffc94d",
          fontSize: 14,
          letterSpacing: 2,
          marginBottom: 8,
          position: "relative",
          zIndex: 1,
        }}
      >
        ★★★★★
      </div>

      <h3
        className="testimonials-item-name"
        style={{
          margin: "0 0 10px",
          fontSize: 20,
          fontWeight: 700,
          color: "#fff",
          position: "relative",
          zIndex: 1,
        }}
      >
        {item.name}
      </h3>

      {/* Divider */}
      <div
        style={{
          width: 40,
          height: 2,
          borderRadius: 2,
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)",
          marginBottom: 18,
        }}
      />

      <p
        style={{
          fontSize: 15,
          lineHeight: 1.7,
          color: "rgba(255, 255, 255, 0.82)",
          fontStyle: "italic",
          margin: 0,
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        {item?.description}
      </p>
    </div>
  );
};

export const Testimonials = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="testimonial" id="Testimonial">
      <style>{`
        .react-multi-carousel-track {
          align-items: flex-start !important;
        }
        .react-multi-carousel-item {
          height: auto !important;
          display: flex !important;
        }
      `}</style>
      <div className="container">
        <div className="row">
          <div>
            <div className="testimonials-bx wow zoomIn">
              <h2>Testimonials</h2>
              {/* <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.<br></br> Lorem Ipsum has been the industry's standard
                dummy text.
              </p> */}
              <Carousel
                responsive={responsive}
                infinite={true}
                customLeftArrow={<CustomLeftArrow />}
                customRightArrow={<CustomRightArrow />}
                className="owl-carousel owl-theme testimonial-slider"
              >
                {TESTIMONIALS.map((item, index) => (
                  <TestimonialCard item={item} key={index} />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CustomLeftArrow = ({ onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "absolute",
        left: 2,
        // top: "50%",
        width: 50,
        height: 50,
        transform: "translateY(-50%)",
        zIndex: 100,
        cursor: "pointer",
        backgroundColor: hover ? "#00000099" : "#00000099",
        borderRadius: "50%",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        transition: "0.3s",
        boxShadow: hover
          ? "2px 1px 5px rgba(255, 255, 255, 0.6)"
          : "2px 1px 5px rgba(255, 255, 255, 0.2)",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        // border: "1px solid #fff9",
      }}
    >
      <span style={{ color: "#fff", fontSize: 30 }}>‹</span>
    </div>
  );
};

const CustomRightArrow = ({ onClick }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "absolute",
        right: 2,
        // top: "50%",
        width: 50,
        height: 50,
        transform: "translateY(-50%)",
        zIndex: 2,
        cursor: "pointer",
        backgroundColor: hover ? "#00000099" : "#00000099",
        borderRadius: "50%",
        // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        transition: "0.3s",
        boxShadow: hover
          ? "2px 1px 5px rgba(255, 255, 255, 0.6)"
          : "2px 1px 5px rgba(255, 255, 255, 0.2)",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <span style={{ color: "#fff", fontSize: 30 }}>›</span>
    </div>
  );
};
